import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './contexts/LanguageProvider';
import { AmenitiesProvider } from '@agape/frontend-utils';
import { amenitiesApi } from './api/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <AmenitiesProvider apiClient={amenitiesApi}>
        <App />
      </AmenitiesProvider>
    </LanguageProvider>
  </React.StrictMode>
);
